import APopup from './Popup.vue';
export default APopup;


// WEBPACK FOOTER //
// ./src/packages/Popup/index.js